/**
 * Slug + client-id helpers for Tips & Guides.
 */

const _TRANSLIT = {
  æ: 'ae', Æ: 'ae',
  ø: 'oe', Ø: 'oe',
  å: 'aa', Å: 'aa',
  ä: 'ae', Ä: 'ae',
  ö: 'oe', Ö: 'oe',
  ü: 'ue', Ü: 'ue',
  ß: 'ss',
  é: 'e', É: 'e', è: 'e', È: 'e', ê: 'e', Ê: 'e',
  á: 'a', Á: 'a', à: 'a', À: 'a',
  ñ: 'n', Ñ: 'n',
};

export function slugify(text) {
  if (!text) return '';
  const lowered = String(text).trim().toLowerCase()
    .split('')
    .map((ch) => _TRANSLIT[ch] ?? ch)
    .join('');
  const cleaned = lowered.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return cleaned.slice(0, 80);
}

// Persistent anonymous client id used to dedupe view-counts per user (per device).
export function getAnonymousClientId() {
  const KEY = 'slushbook_client_id';
  try {
    let cid = localStorage.getItem(KEY);
    if (!cid) {
      cid = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(KEY, cid);
    }
    return cid;
  } catch (_e) {
    return null;
  }
}
